// Square Configuration
// export const SQUARE_CONFIG = {
//   applicationId: process.env.REACT_APP_SQUARE_APPLICATION_ID || 'sandbox-sq0idb-6YBgVuVelofTScU0U1bd3w',
//   locationId: process.env.REACT_APP_SQUARE_LOCATION_ID || 'LJ5HKED3XQVYB',
//   environment: process.env.REACT_APP_SQUARE_ENVIRONMENT || 'sandbox'
// };

export const SQUARE_CONFIG = {
  applicationId: process.env.REACT_APP_SQUARE_APPLICATION_ID || 'sq0idp-FzYPWHOKcZlMRBaLovnYpA',
  locationId: process.env.REACT_APP_SQUARE_LOCATION_ID || 'LCXKAZGMY3X9X',
  environment: process.env.REACT_APP_SQUARE_ENVIRONMENT || 'production'
};

// Get the correct Square SDK URL based on environment
export const getSquareSDKUrl = () => {
  return SQUARE_CONFIG.environment === 'sandbox' 
    ? 'https://sandbox.web.squarecdn.com/v1/square.js'
    : 'https://web.squarecdn.com/v1/square.js';
};